.bm{justify-content:flex-end;}